import { FC } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { HttpErrorDisplayTemplate } from '../errors/HttpErrorDisplayTemplate';
import translations from './NotFound.translations.json';
import errorImg from '../assets/img/not-found.png';
import clouds from '../assets/img/clouds.svg';

const { addTranslations, useTranslation } = i18nNsFactory('not-found');
addTranslations(translations);

export const NotFound: FC = () => {
  const { t } = useTranslation();
  return (
    <HttpErrorDisplayTemplate
      beforeImage={<img src={clouds} alt="error illustration" />}
      imgSrc={errorImg}
      title={t('title')}
    >
      {t('text')}
    </HttpErrorDisplayTemplate>
  );
};
